<div class="content-order my-content">

  <div class="container" fxLayout="row wrap" fxLayoutAlign="center start">
    Hola mundo
    <br>
    <!-- {{shipment}} -->
  </div>
</div>
